import React from 'react';
import styles from './Help.module.sass';

function Help() {
  return (
    <div className={styles.help}>
      <div className={styles.title}>
        having trouble deciding?
      </div>
      <div className={styles.hints}>
        <div className={styles.hint}>
          <div className={styles.small}>
            Close your eyes and think of your campaign.
          </div>
          <div className={styles.big}>
            What color comes to mind?
          </div>
        </div>
        <div className={styles.hint}>
          <div className={styles.small}>
            Pick a color that sparked your innovation.
          </div>
          <div className={styles.big}>
            What color surrounded you in the making?
          </div>
        </div>
        <div className={styles.hint}>
          <div className={styles.small}>
            Pick a color that accents your ingredients.
          </div>
          <div className={styles.big}>
            Go matchy-matchy or go complementary.
          </div>
        </div>
      </div>
    </div>
  );
}

export default Help;
